import { useMutation } from "@tanstack/react-query";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { createProjectApi } from "@/API/createProjectApi";
import { ShowNotification } from "@/components/ShowNotification";
import { useErrorBoundary } from "@/hooks/helperHooks/useErrorBoundary";

export interface ProjectDataProps {
  name: string;
  description?: string;
  deadline?: Date | null;
}

const useCreateProject = () => {
  const { invalidateProjects } = useInvalidateQueries();
  const handleError = useErrorBoundary();

  return useMutation<void, Error, ProjectDataProps>({
    mutationFn: ({ name, description, deadline }) =>
      createProjectApi(name, description, deadline),

    onSuccess: () => {
      invalidateProjects();
      ShowNotification({
        title: "Success",
        message: "New project has been created!",
        color: "success",
      });
    },

    onError: (error: Error) => {
      ShowNotification({
        title: "Error",
        message: "Failed to create a new project.",
        color: "error",
      });
      handleError(error);
    },
  });
};

export default useCreateProject;
